<template>
  <Modal
    v-model="_value"
    width="400"
    title="SIM卡绑定师傅"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form v-if="simInfoList.length > 0" ref="loginForm" :model="simInfoList">
      <div v-for="item in simInfoList">
        <FormItem prop="simNum" label="SIM卡号">
          <label style="display: inline-block;">{{item.simNum}}</label>
        </FormItem>
      </div>
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="simInfo.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Form v-else ref="loginForm" :model="simInfo">
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="simInfo.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'siminfochangeinstallermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      installers: [],
      simInfo: {
        id: null,
        installerId: null
      },

      simInfoList: [],
      simInfoIds: []
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_ChangeInstaller',
      'UserServ_GetAllUsers',
      'InstallOrderServ_GetDetail'
    ]),
    onOk () {
      if (this.simInfoList != null && this.simInfoList.length > 0) {
        store.dispatch('SimInfoServ_BatchChangeInstaller', {
          params:
            {
              ids: this.simInfoIds,
              installerId: this.simInfo.installerId
            },
          urlparams: null
        }).then(() => {
          this.$Message.success('绑定安装员成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '指派安装员',
          content: '<p>确认绑定安装员</p>',
          onOk: () => {
            store.dispatch('SimInfoServ_ChangeInstaller', {
              params: {
                id: this._initValue,
                installerId: this.simInfo.installerId
              }
            }).then(() => {
              this.$Message.success('绑定安装员成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        console.log(this._listValue)
        this.simInfoList = this._listValue
        this.simInfoIds = []
        if (this.simInfoList != null && this.simInfoList.length > 0) {
          this.simInfoList.forEach(item => {
            this.simInfoIds.push(item.id)
          })
        } else {
          this.simInfoIds = []

          this.simInfo.id = null
          this.simInfo.installerId = null

          let simInfoId = this._initValue
          if (simInfoId) {
            store.dispatch('SimInfoServ_GetDetail', {
              params: { id: simInfoId }
            }).then(() => {
              this.simInfo = store.getters.get_SimInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          let installers = []
          store.getters.get_User_GetAllUsersResult.forEach(item => {
            if (item.state === 1) {
              installers.push(item)
            }
          })
          this.installers = installers
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
